import type { HeaderRedesignSchema } from '../components/Header/schema'

export const includeImage = <T extends { readonly imageId: string }>(
  item: T,
  images: HeaderRedesignSchema['images']
) => ({
  ...item,
  image: images.items.find(img => img.contentful_id === item.imageId)
})
